import React, { FC } from 'react';
import cx from 'classnames';
import useThemeBlock from '@/hooks/useThemeBlock';
import block from './block.json';
import { getStyles } from './styles.css';

export type ColumnsProps = ChildrenProps & ThemeProps;

export const Columns: FC<ColumnsProps> & BlockConfigs = ({
	children,
	theme = {},
}) => {
	const { variant /*, blockTheme*/ } = useThemeBlock(block.slug, theme);

	const htmlProps = {
		'data-variant': variant,
	};

	const rootClass = cx('supt-columns', getStyles());

	return (
		<div className={rootClass} data-block={block.slug} {...htmlProps}>
			{children}
		</div>
	);
};

Columns.slug = block.slug;
Columns.title = block.title;
